import React from 'react'
import NextStep from './NextStep'
import CHANNEL_NextStep from './CHANNEL_NextStep'
import AvailableMethods from '../Components/AvailableMethods'
import SuccessPage from '../Components/SuccessPage'
import MoneyInput from '../Components/MoneyInput'
import BankSelect from '../Components/BankSelect'
import TipsView from '../Components/TipsView'
import SubmitBtn from '../Components/SubmitBtn'
import { DepositHeader } from '../index'
import Modal from "../Components/Modal";
import CTCCon from '$Deposits/Components/CTC'
import { GetParamsData } from '$Deposits/lib/LibCommonData';

class CTC extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            modalVisible: false,
        };
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }
    openTutorial =(v)=> {
        const { openTutorial } = GetParamsData()
        openTutorial(v)
    }
    render() {


        return (
            <>
                <div className='methodsActive'>
                    <div className='CIC-help' onClick={()=>this.openTutorial("DCTC")}>
                        <span>Hướng Dẫn Gửi Tiền</span>
                    </div>
                    <CTCCon
                        Modal={(propCon) => {
                            const { modalVisible, code, onChange, onCancel } = propCon
                            return (
                                <Modal
                                    className={`modalTips ${code}-modal`}
                                    visible={modalVisible}
                                    title='Lưu Ý Quan Trọng'
                                    okText='Xác Nhận'
                                    onOk={onChange}
                                    cancelText={'Đóng'}
                                    onCancel={onCancel}
                                >
                                    <>
                                        <div className='titleIcon'>
                                            <span className={code + 'Icon CTCimgIcon'} />
                                            <span>Tether USD ({code})</span>
                                        </div>
                                        <p className="intro introBlue left">
                                            Vui lòng chỉ gửi USDT đến địa chỉ ví ở bước tiếp theo. Nếu gửi bất kỳ tiền mã hóa khác có thể dẫn đến mất số tiền bạn đã gửi vào.
                                        </p>
                                        <p className="intro left">
                                            Bằng cách nhấp vào nút "Xác Nhận",  bạn đã đồng ý và chấp nhận rủi ro đề cập ở trên.
                                        </p>
                                    </>
                                </Modal>
                            )
                        }}
                        TipsView={TipsView}
                        AvailableMethods={AvailableMethods}
                        MoneyInput={MoneyInput}
                        BankSelect={BankSelect}
                        SubmitBtn={SubmitBtn}
                        NextStep={NextStep}
                        CHANNEL_NextStep={CHANNEL_NextStep}
                        SuccessPage={SuccessPage}

                    />
                </div>
            </>
        );
    }
}


export default CTC



